"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var purchase_service_1 = require("./purchase-service");
var package_service_1 = require("./package-service");
var license_service_1 = require("./license.service");
function bhtpPurchaseServiceFactory(http) {
    return new purchase_service_1.BhtpPurchaseService(http);
}
exports.bhtpPurchaseServiceFactory = bhtpPurchaseServiceFactory;
function bhtpPackageServiceFactory(http) {
    return new package_service_1.BhtpPackageService(http);
}
exports.bhtpPackageServiceFactory = bhtpPackageServiceFactory;
function bhtpLicenseServiceFactory(http) {
    return new license_service_1.BhtpLicenseService(http);
}
exports.bhtpLicenseServiceFactory = bhtpLicenseServiceFactory;
/**
 * The module that includes http's providers
 *
 * @experimental
 */
var BhtpPurchaseServiceModule = (function () {
    function BhtpPurchaseServiceModule() {
    }
    return BhtpPurchaseServiceModule;
}());
BhtpPurchaseServiceModule = __decorate([
    core_1.NgModule({
        providers: [
            // TODO(pascal): use factory type annotations once supported in DI
            // issue: https://github.com/angular/angular/issues/3183
            { provide: purchase_service_1.BhtpPurchaseService, useFactory: bhtpPurchaseServiceFactory, deps: [http_1.Http] },
            { provide: package_service_1.BhtpPackageService, useFactory: bhtpPackageServiceFactory, deps: [http_1.Http] },
            { provide: license_service_1.BhtpLicenseService, useFactory: bhtpLicenseServiceFactory, deps: [http_1.Http] },
        ],
    })
], BhtpPurchaseServiceModule);
exports.BhtpPurchaseServiceModule = BhtpPurchaseServiceModule;
//# sourceMappingURL=D:/a/1/s/purchase/src/purchase-module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/purchase-module.js